import axios from 'axios';
import { getCookie } from '@hfc/ui-core';

const instance = axios.create({});

instance.interceptors.request.use((config) => {
  const token = getCookie('hfcApiToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export default instance;
